import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './TermsOfService.css';

const TermsOfService = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div class="WordSection1">
        <>
          <h1>
            <b>
              <span className={css.cl1}> Terms of Use </span>
            </b>
          </h1>
          <p className={css.cl6}>
            <span className={css.cl1}> Last updated: 18 August 2025 </span>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              These terms and conditions apply when you use our Platform or the Rental Services
              (these <b>Terms</b>). You agree to be bound by these Terms.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 1. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> The Rental Services </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) Kindershare operates an online marketplace that allows an Owner to rent out
              Children’s Equipment to a Renter via the Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) These Terms govern your use of the Rental Services and your use of the Platform.
              By using the Rental Services and the Platform, you agree to these Terms. If you do not
              agree to the Terms, you may not use the Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>You may only use the Rental Services and the
              Platform if you are 18 years or over.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 2. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Registration </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(a) You may access our Platform by using our Website.</span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) To use the Rental Services, you need to register as a user on our Website and
              agree to certain terms and conditions.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>When registering as a user of the Platform,
              you must:
            </span>
          </p>
          <p className={css.cl14}>
            <span className={css.cl1}>
              (i) provide us with accurate, complete and up-to-date registration information (and
              update that information from time to time, as needed );
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) provide your credit card or debit card details, which will be held by our
              third-party payment platform provider; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) not register as a user more than once using a different email address or
              impersonate or create a user registration for any person other than yourself.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(d) As a registered user of the Platform, you must:</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>take reasonable steps to ensure the
              security and confidentiality of your user registration details, including any username
              and/or password that you select;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) notify us immediately if you become aware of any unauthorised use of your
              account; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) change your password or any other registration information if we ask you to do
              so.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) You are responsible for all activities which occur under your user details because
              of your failure to keep your registration information secure and confidential
              (including unauthorised rentals or transfers).
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 3. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Owner terms </span>
            </b>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 3.1 General </span>
            </b>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              This clause 3 (the <b>Owner Terms</b>) set out the legal terms between us and each
              Owner in relation the renting out of Children’s Equipment by the Owner via the
              Platform. In this clause 3, references to “you” or “your” mean the Owner.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 3.2 Renting out of Children’s Equipment </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) To enable the rental of the Children’s Equipment, you must list the Children’s
              Equipment on the Platform, including the detail, make and model of the Children’s
              Equipment, photographs and any other relevant details.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) You must ensure that it accurately described the Children’s Equipment and will not
              present an undue safety risk to the Renter (or any other person).
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>By submitting or posting Children’s Equipment
              for rent on our Website, you represent and warrant that:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>you own the Children’s Equipment or have
              the consent of the owner to rent it out;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) you are not aware of the Children’s Equipment being subject to a ban or a product
              recall, after having made reasonable inquiries with Product Safety Australia and
              Product Safety Recalls;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) you purchased the Children’s Equipment in Australia or that the equipment is
              otherwise compliant with Australian Standards;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iv) the Children’s Equipment is not more than 7 years old, calculated from the date
              of purchase;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (v) the information you provided on the Website about the Children’s Equipment is
              accurate, genuine and not misleading or deceptive; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (vi) you are not infringing the Intellectual Property Rights of any person when
              posting photos or other details of the Children’s Equipment.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(d) You also understand that we do not:</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>review Children’s Equipment posted on the
              Platform, or endorse or guarantee the accuracy of any listing on the Platform; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) guarantee that an Owner will be able to find Renters for the Children’s Equipment
              via the Platform or make revenue from that Children’s Equipment.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) You may rent out the Children’s Equipment via the Platform for any period you
              consider appropriate, provided it is not less than 1 day.
            </span>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (f)
              <span className={css.cl8}>&nbsp;&nbsp; </span>You have the option to rent out the
              Children’s Equipment to the Renter by accepting a rental request through the Platform
              and completing the Rental Services. You are free to determine:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>the price, dates and duration of the
              rental; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>(ii) to whom you will rent the Children’s Equipment.</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (g)
              <span className={css.cl8}>&nbsp; </span>In addition, you may specify the cancellation
              policy that will apply to your rental, which may be either:{' '}
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>a no refund policy, where no refunds are
              to be provided; or
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii)
              <span className={css.cl8}>&nbsp; </span>a full refund policy, where a refund is
              allowed until the start date of the Rental Period.
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) Regardless of the cancellation policy you select, if a government-imposed travel
              restriction or public health order (such as those related to COVID-19) is in place,
              the Renter will be entitled to cancel a rental without liability for the Rental
              Charges.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 3.3 Our role and responsibilities </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(a) We will:</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>for the time the Children’s Equipment is
              listed for rent on the Platform promote the Children’s Equipment on the Platform for
              rent, without any charge or commission to you;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>(ii) provide you with the Rental Services; and</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) facilitate communications between you and Renters in relation to the
              organisation of a Direct Pick Up/Drop Off in relation to the Children’s Equipment.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) We may also advertise links to the Children’s Equipment on third party websites to
              increase exposure and increase your opportunities to earn rental income from the
              Children’s Equipment. We may also use the photos of the Children’s Equipment you
              upload to the Platform to market and promote the Platform and the Rental Services.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>We will, via the Platform, facilitate the
              payment of the Rental Charges to you, after deducting the Kindershare Fee and
              applicable taxes (if any). We will also, for your benefit, place a hold on the
              Renter’s credit card or debit card for the Bond amount, if any, you have specified.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (d) Our liability to you for any loss, damage or theft of the Children’s Equipment
              when in the possession of the Renter, or loss or theft of any other items associated
              with the Children’s Equipment, will be limited to:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>payment of the Bond (if applicable) to
              you in the case of loss, damage or theft; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) if the Bond is required by you and is set at 20% or higher than the replacement
              cost of the relevant item, reimbursement of 75% of the market value of a replacement
              item in the case of loss, damage or theft, reduced to take account of the pay-out of
              any Bond amount paid to you, as further explained in clause 5.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) Other than our liability to you under clause 3.3(c), we are not liable to you for:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>the condition of the Children’s Equipment
              before or after the Rental Period;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) any claims made by the Renter against you in relation to the rental of the
              Children’s Equipment;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) any incidental expenses incurred by the Owner in relation to the rental of the
              Children’s Equipment;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iv) any failure by the Renter to comply with the Renter Terms; or
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>(v) any failure by you to comply with these Terms.</span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 3.4 Handover of Children’s Equipment and payment </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) You must, through the Platform, confirm with the Renter arrangements for the
              handover of the Children’s Equipment via Direct Pick Up/Drop Off. Other than
              facilitating the Direct Pick Up/Drop Off, we are not involved in that activity.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) Prior to the handover of the Children’s Equipment, you must ensure that:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>the Children’s Equipment is clean, in
              working condition and fit for the purpose for which it is designed; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) all personal belongings are removed from the Children’s Equipment (and if such
              belongings are not removed, then these are at your risk).
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c) You must handover the Children’s Equipment at the time and date agreed with the
              Renter as part of a Direct Pickup/Drop Off.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (d) At the handover of the Children’s Equipment to the Renter:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>you must confirm to the Renter any
              pre-existing damage or issue with the Children’s Equipment; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) you must use reasonable efforts to show the Renter how to use the Children’s
              Equipment (if relevant) and to answer any reasonable queries from the Renter.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) We will, for each item of Children’s Equipment being rented out via the Platform
              (as shown on the Platform at the time of transaction), pay you:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>your proportion of the Rental Charges
              (after deducting the Kindershare Fee); and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) any delivery fees that you charge for Direct Pick Up/Drop Off.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (f)
              <span className={css.cl8}>&nbsp;&nbsp; </span>We will also hold any Bond that you may
              require from the Renter on your behalf and pay this out to you in the case of loss,
              damage or theft of the Children’s Equipment.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (g) The Rental Services commence from the time of handover of the Children’s Equipment
              and continue for the duration agreed, via the Platform, between you and the Renter
              (the <b>Rental Period</b>). Risk in the Children’s Equipment transfers to the Renter
              from the start of the Rental Period.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (h) You acknowledge that, as you have received payment of the Rental Charges following
              handover of the Children’s Equipment to the Renter, you cannot cancel the rental
              before the end of the Rental Period.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 3.5 Return of Children’s Equipment </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) At the time of return of the Children’s Equipment, you must inspect the Children’s
              Equipment and check that the Children’s Equipment (including any provided accessories)
              is returned in the same condition as it was at the beginning of the Rental Period,
              save for any reasonable wear and tear and any pre-existing damage or issue with the
              Children’s Equipment identified previously at the time of initial Pick Up/Drop off.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) You must notify us of any failure to return, or damage to, the Children’s
              Equipment within 24 hours of the end of the Rental Period (or any earlier return
              date). If you notify us of a failure to return, or damage to the Children’s Equipment
              within this period, we will investigate the matter, follow up with the Renter and seek
              the return of the Children’s Equipment, if possible. If we are unable to assist you in
              successfully recovering the item after taking these steps or the item is confirmed to
              be lost, damaged or destroyed, then we will pay out the Bond (if applicable) to you
              and you may also be eligible to make a claim under the Kindershare Guarantee.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>You understand that a failure to notify within
              this time will result in the return of any Bond to the Renter and may also disqualify
              you from receiving the Bond and making a claim under the Kindershare Guarantee.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (d) If the Children’s Equipment is returned before the end of the Rental Period, you
              must notify us of this fact so we can return any Bond (if applicable) to the Renter.
              You will not need to provide a refund of your proportion of the Rental Charges if the
              Children’s Equipment is returned early.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 4. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Renter terms </span>
            </b>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 4.1 General </span>
            </b>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              The terms in this clause 4 (the <b>Renter Terms</b>) set out the legal terms between
              us and each Renter in relation the rental of Children’s Equipment by the Renter via
              the Platform. In this clause 4, references to “you” or “your” mean the Renter.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 4.2 Your role and responsibilities </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(a) You understand that we do not:</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>review Children’s Equipment posted on our
              Platform, or endorse or guarantee the accuracy of any listing and associated
              information that may be posted on our Platform; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) make any representation or guarantee in relation to the Children’s Equipment you
              rent via the Platform, including its suitability for your requirements.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) You must not (and must ensure that any other person using the Children’s Equipment
              does not):
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>use the Children’s Equipment for any
              illegal purpose, including in a manner that would breach road safety legislation or
              the criminal law;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) use the Children’s Equipment in a way, or to support an activity, for which it is
              not designed;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) use the Children’s Equipment in an unsafe, reckless or dangerous manner, or in a
              manner that would present any undue safety risk to any person;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iv) carry anything that would cause the Children’s Equipment to be overloaded; or
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (v) sell, rent or dispose of the Children’s Equipment (or any accessories provided
              with such equipment) or register or attempt to register any interest in that equipment
              under the Personal Property Securities Act 2009.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>You must (and must ensure that any person
              using the Children’s Equipment):
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>ensure that the Children’s Equipment is
              kept safe and secure;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) keep the Children’s Equipment in clean and in a proper working condition;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) use all reasonable efforts to avoid theft or loss of, or damage to, the
              Children’s Equipment; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iv) immediately report any theft, loss, or damage to the Children’s Equipment to the
              Owner using the Platform's messaging feature and to Kindershare.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 4.3 Cancellation </span>
            </b>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (a)
              <span className={css.cl8}>&nbsp; </span>You may cancel a rental via the Platform on or
              prior to the start date.
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>(b) If you cancel a rental: </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;</span> where the Owner has selected a full refund
              policy in respect of the rental item, then you will not be liable to pay the Rental
              Charges for the Rental Period; or
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) where the Owner has selected a no refunds policy, you will remain liable to pay
              the Rental Charges for the Rental Period.
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (c) Notwithstanding clause 4.3(b), you may still cancel a rental without being liable
              for the Rental Charges if you become impacted by a government-imposed travel
              restriction or public health order (such as those related to COVID-19).
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (d)
              <span className={css.cl8}>&nbsp; </span>In addition, we may cancel the Rental Services
              without penalty to the Renter if the Children’s Equipment becomes unavailable or due
              to the actions or conduct of the Owner.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 4.4 Handover and return of Children’s Equipment </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) You must, via the Platform, confirm with the Owner arrangements for the handover
              of the Children’s Equipment via Direct Pick Up/Drop Off. Other than facilitating the
              Direct Pick Up/Drop Off, we are not involved in that activity.
            </span>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (b) At the initial handover of the Children’s Equipment, you must immediately notify
              the Owner using the Platform's messaging feature if you notice any pre-existing damage
              or issue. You must also provide us with details via the Platform within 24 hours of
              the time of Pick Up/Drop Off.
            </span>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (c) If requested by the Owner, you will provide proof of your identity (e.g. a
              driver’s licence) and that you are the Renter.
            </span>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (d) If you do not wish to proceed with the rental to the Children’s Equipment (e.g.
              due to pre-existing damage, etc.), you must notify our customer support team that you
              do not wish to proceed with the rental, in which case the Rental Services will be
              cancelled for that item.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) If you proceed with the rental of the Children’s Equipment, we will for each item
              of Children’s Equipment being rented via the Platform (as shown on the Platform at the
              time of transaction):
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>charge your credit card or debit card:
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (A) the Rental Charges (from which will deduct the Kindershare Fee before paying to
              the Owner);
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (B) any delivery fees applicable for Direct Pick Up/Drop Off provided by the Owner;
              and
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(C) any applicable taxes (if any); and</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) apply a hold on your credit or debit card for the Bond amount (if required by the
              Owner), which we will either:
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (A) remove at the end of the Rental Period if there is no theft, loss or damage to the
              Children’s Equipment (after deducting any merchant and bank processing fees); or
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (B) charge against your credit card or debit card if there is theft, loss or damage of
              the Children’s Equipment (plus any merchant or bank processing fees),
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (together, the <b>Total Fee</b>).
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (f)
              <span className={css.cl8}>&nbsp;&nbsp; </span>The Renter is responsible for the
              Children’s Equipment during the Rental Period. Risk in the Children’s Equipment
              transfers to the Renter from the start of the Rental Period and back to the Owner from
              time of return of the Children’s Equipment.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (g) You must return the Children’s Equipment to the Owner in the same condition as at
              the start of the Rental Period, save for reasonable wear and tear and any pre-existing
              damage or issues identified at the time of Direct Pickup/Drop Off. You are responsible
              for all loss or damage and any third-party loss that occurs during the Rental Period.
            </span>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (h) If there is any loss, damage or theft of the Children’s Equipment during the
              Rental Period, or a failure to return the Children’s Equipment at the end of the
              Rental Period, you agree that:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>you will forfeit the Bond, if applicable,
              and we will charge your credit card or debit card the amount of the Bond; and
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (ii) if the Bond required by the Owner is set at 20% or higher than the replacement
              cost of the relevant item, we will also charge your credit card or debit card for 75%
              of the market value of a replacement item (deducted to take account of any Bond that
              you have forfeited). For example, if the replacement value of a pram that is lost is
              $1,000 and the Bond for that item was $200, then you would be charged $550, calculated
              as follows: ($1,000 * 0.75) - $200 = $550.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              However, where it is reasonably possible replace the damaged part of an item rather
              than the entire item (e.g. where we can replace a damaged storage compartment on a
              pram, rather than the pram in its entirety), we will only charge you for the costs of
              the replacement item (plus delivery costs). If a Bond amount applies to the relevant
              item, we will deduct that amount from the Bond amount, if any, in the first instance
              before recovering the remaining cost from you.
              <span className={css.cl8}>&nbsp;</span>You acknowledge that:
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (A) you have agreed to making this payment at the time of renting the relevant item;
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (B) you have made the appropriate declaration via a tick box on the Platform at the
              time of the transaction; and
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (C) your credit card or debit card details are held on file by our third-party payment
              platform provider for this purpose.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>Other than where there is theft, loss or
              damage to the Children’s Equipment notified by the Owner, or the Renter fails to
              return the Children’s Equipment at the end of the Rental Period, we will refund the
              Bond to you, if applicable, and remove any hold on your credit card or debit card for
              that amount. The time taken for the Bond to be refunded or for a hold on a credit card
              or debit card to be removed will vary depending on the bank processing times..
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (j)
              <span className={css.cl8}>&nbsp;&nbsp; </span>If you return the Children’s Equipment
              to the Owner before the end of the Rental Period, you will not receive any refund or
              adjustment of the Total Fee.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (k)
              <span className={css.cl8}>&nbsp; </span>You understand that if the Children’s
              Equipment is not returned at the time and date agreed with the Renter, the Owner may
              report the Children’s Equipment as stolen.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 5. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Kindershare Guarantee for loss, damage and theft </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a)
              <span className={css.cl8}>&nbsp; </span>Where an Owner has specified a Bond for an
              item of Children’s Equipment that is 20% or more than the replacement value of that
              item, we will provide each Owner with automatic cover for theft, loss or damage to the
              Children’s Equipment notified by the Owner (excluding reasonable wear and tear and all
              pre-existing damage), or a failure by the Renter to return the Children’s Equipment at
              the end of the Rental Period.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(b) If the Children’s Equipment is:</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>lost, damaged or stolen, the Renter must
              immediately notify the Owner and Kindershare; or
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii)
              <span className={css.cl8}>&nbsp; </span>not returned by the Renter at the end of the
              Rental Period, the Owner must immediately notify the Owner and Kindershare.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>Subject to clause 5(d), we will provide the
              Owner with reimbursement of 75% of the market value of the Children’s Equipment that
              has been lost, damaged or stolen, less the amount of the Bond paid to the Owner (if
              applicable). For example, if the market value of a pram that is lost is $1,000 and the
              Bond for that item was $200, then the pay-out would be determined as follows:
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>($1,000 * 0.75) - $200 = $550.</span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              Notwithstanding the above, where it is possible to replace a damaged part of the
              Children’s Equipment rather than the entire item (e.g. a storage compartment of a pram
              as opposed to the entire pram), we will deduct the full replacement cost of that item
              (plus delivery costs) from the Bond and refund the remaining balance of the Bond to
              the Owner. For example, if the bond for a pram is $200 and the replacement part costs
              $85.00 with a $15.00 delivery cost, we will deduct $100 from the Bond and refund the
              remaining $100.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (d) We will not provide a reimbursement for items of Children’s Equipment:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>where the Owner has not specified a Bond
              that equals 20% or more of the replacement value of the relevant item;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) where the loss or damage, in our reasonable opinion, is a function of reasonable
              wear and tear;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) where the loss or damage relates to, or has arisen from, pre-existing damage to
              the relevant item;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iv) where the Owner and the Renter have given effect to a rental transaction outside
              of the Platform;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>(v) where the Owner has breached these Terms; or</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (vi) where, in our reasonable opinion, we consider that the request for reimbursement
              is fraudulent or based on questionable facts or circumstances (e.g. repeated claims
              for reimbursement by an Owner) or otherwise unreasonable.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) The Owner and Renter will co-operate with us, and comply with all reasonable
              directions we may give, in relation to a reimbursement under this clause.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 6. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Cancellation </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              We may terminate these Terms, including your use of the Rental Services and the
              Platform, if you commit a material breach of these Terms. If you don’t remedy a
              material breach within any reasonable period that we specify or such a breach cannot
              be remedied, we may terminate these Terms and any Rental Services with immediate
              effect by giving you written notice.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 7. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Fees and payment processing </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) Payment pre-requisite to rental: If you are a Renter, you will not be able to rent
              the Children’s Equipment unless you pay the Total Fee.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) Applicable taxes: Each component of the Total Fee will be subject to any
              applicable taxes, if required by law.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>Payments processed by third party: All
              payments are processed and managed by our third-party payment platform provider. We do
              not collect your payment information. Your use of the Rental Services is subject to
              the terms and conditions of use of our third-party payment platform provider, as
              further described in clause 7(d). We are not responsible to you for your use of their
              payment gateway and not liable in relation to any information provided to or via the
              payment gateway.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (d) Stripe terms: Payment processing services on Kindershare are provided by Stripe
              and are subject to the{' '}
              <span>
                <a href="https://stripe.com/connect-account/legal">
                  <span className={css.cl5}>Stripe Connected Account Agreement,</span>
                </a>
              </span>{' '}
              which includes the{' '}
              <span>
                <a href="https://stripe.com/legal">
                  <span className={css.cl5}>Stripe Terms of Service</span>
                </a>
              </span>{' '}
              (collectively, the <b>Stripe Services Agreement</b>). By agreeing to these Terms or
              continuing to hold an account on Kindershare, you agree to be bound by the Stripe
              Services Agreement, as may be modified by Stripe from time to time. As a condition of
              the Platform enabling payment processing services through Stripe, you agree to provide
              Kindershare accurate and complete information about you and your business, and you
              authorise Kindershare to share it and transaction information related to your use of
              the payment processing services provided by Stripe.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) Free / trial services: We may issue promo codes that allow you to use the Rental
              Services for free or at a discount (<b>Promotional Discount</b>). You will be eligible
              for a Promotional Discount if you comply with any applicable terms and conditions,
              including any eligibility criteria or claim process.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 8. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Conditions of use </span>
            </b>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 8.1 Ownership of Platform </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) We are the sole owner of the Platform. Your rights in the Platform are limited to
              using it for the Rental Services.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) The Platform contains content that is protected by our Intellectual Property
              Rights and those belonging to third parties. We are the owners of these Intellectual
              Property Rights or have a right to use these Intellectual Property Rights from those
              third parties. Subject to your compliance with these Terms, we grant to you a
              revocable, non-exclusive, non-assignable and non-transferable licence to access the
              content on your device for the sole purpose of using the Rental Services for your
              personal use.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 8.2 Platform not free from faults, etc. </span>
            </b>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              We cannot guarantee that our Platform is free from faults or interruptions. Your
              access to the Platform may be suspended without notice due to faults or interruptions,
              maintenance or for any reason beyond our control.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 8.3 Changes to Platform </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              We may update, improve, change or discontinue any functionality, feature or service on
              the Platform at any time.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 8.4 Your use of the Platform </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) You must comply with these Terms as a condition of your access to the Platform and
              use of the Rental Services.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) You are solely responsible for your use of the Platform and any actions you take
              or decisions you make as part of your use of the Rental Services.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>We will use reasonable endeavours to ensure
              that the Platform is safe and secure. However, you understand that:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>transmissions on the internet may never
              be completely private or secure;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) we cannot be responsible for, and accept no liability for, the conduct of any
              other user of the Platform;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (iii) we cannot ensure that any images, files or other data you download, share or
              obtain from the Platform (if you are permitted to do so) will be free of viruses or
              contamination or destructive features;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iv) we cannot guarantee that your access will be uninterrupted, timely, secure, error
              free, or that any defects will be corrected, or that your use of the Platform will
              provide specific results or benefits and we will not be liable for the same; and
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (v)
              <span className={css.cl8}>&nbsp; </span>other than as provided in these Terms, your
              sole remedy against us for dissatisfaction with the Platform is to stop using the
              Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(d) You must not:</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>use the Platform in breach of any
              applicable laws or regulations;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) use the Platform (or content obtained from the Platform):
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (A) to transmit (or authorise the transmission of) “junk mail”, “chain letters”,
              unsolicited emails, “spamming” or other untargeted, unwanted or repetitive content,
              other than to share links to the Children’s Equipment you plan to make available
              through the Platform (and associated information, such as reviews );
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(B) to impersonate any person or entity;</span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (C) to solicit money, passwords or personal information from any person; or
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (D) to harm, abuse, harass, stalk, threaten or otherwise offend others;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (iii) use or attempt to use the Platform to upload, post, transmit or otherwise make
              available any material that, in our opinion:
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (A) infringes (or could reasonably be expected to infringe) our Intellectual Property
              Rights or other rights, or those of another person;
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (B) contains, promotes or provides information about unlawful activities or conduct;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (C) is, or could reasonably be expected to be, defamatory, obscene, offensive,
              threatening, abusive, vulgar, profane or otherwise unlawful, including Material that
              racially or religiously vilifies, contains cruelty or abuse (including to animals),
              incites violence or hatred, or is likely to offend, insult or humiliate others based
              on race, religion, ethnicity, gender, age, sexual orientation or any physical or
              mental disability;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (D) includes an image or personal information of another person or persons unless you
              have their consent;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (E) poses or creates a privacy or security risk to any person;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (F) you know or suspect (or ought reasonably to have known or suspected) to be false,
              misleading or deceptive;
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (G) contains viruses, or other computer codes, files or programs designed to
              interrupt, limit or destroy the functionality of other computer software or hardware;
            </span>
          </p>
          <p className={css.cl13}>
            <span className={css.cl1}>
              (H) advertises, promotes or solicits any goods or services or commercial activities,
              other than the rental of Children’s Equipment via the Platform;
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (I)
              <span className={css.cl8}>&nbsp;&nbsp; </span>seeks to direct users of the Platform to
              an alternative platform or website to acquire goods or services, or which otherwise
              markets or promotes to other users of the Platform any other goods or services or
              commercial activities;
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (J)
              <span className={css.cl8}>&nbsp; </span>interferes with, or disrupts the Platform or
              any systems, or networks connected to the Platform; or
            </span>
          </p>
          <p className={css.cl9}>
            <span className={css.cl1}>
              (K) uses any deep-link, page-scrape, robot, spider or other automatic device, program,
              algorithm, or methodology or any similar process to retrieve, index, or in any way
              reproduce, modify or circumvent the navigational structure, security or presentation
              of the Platform or any content on it;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iv) arrange, or attempt to arrange, any booking or payment for rental items outside
              of the Platform to circumvent the Kindershare Fee or for any other reason;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (v) copy, store, alter, reproduce, republish, upload, post, display, transmit or
              distribute any part of the Platform to any other device, server, website or other
              medium for publication or any commercial enterprise or use;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (vi) use code or any other means to direct other persons to any other web page;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (vii) probe, scan or test the vulnerability of the Platform or any network connected
              to the Platform, nor breach the security or authentication measures on the Platform or
              any network connected to the Platform, including by hacking, password mining or any
              other illegitimate means;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (viii) modify, adapt, sublicense, translate, sell, reverse engineer, decipher,
              decompile or otherwise disassemble any portion of the Platform or cause any other
              person to do so.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) We reserve the right to, in our sole discretion, suspend or terminate your use of
              the Platform, including if we believe you:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>are abusing the use of the Platform in
              any way;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>(ii) have breached these Terms; or</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) have attempted to arrange bookings or payments outside of the Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (f)
              <span className={css.cl8}>&nbsp;&nbsp; </span>If we suspend or terminate your use of
              the Platform, we may:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>delete and/or remove or prevent further
              access to your information; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) refuse to allow you future access to the Platform or the Rental Services.
            </span>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (g) We may remove, take down, modify and/or remedy any reference, post, share or
              upload you make on our Platform if we consider that it breaches these Terms.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> 8.5 Third Party Links </span>
            </b>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (a)
              <span className={css.cl8}>&nbsp; </span>The Platform may feature or display links and
              pointers to websites, content and advertising owned and/or operated by third parties (
              <b>Third-Party Links</b>).
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) Third Party Links (if any) do not form part of the Platform and are not under our
              control. By featuring or displaying such Third-Party Links we do not represent that we
              recommend or endorse the relevant third party, its products or services. We do not
              accept any responsibility for any Third-Party Links.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 9. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Privacy </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              The Privacy Policy can be found on the Platform and applies to your use of the
              Platform and the Rental Services. The Privacy Policy may be changed from time to time
              and is effective immediately upon posting such changes on the Platform.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 10. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Liability </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) The Rental Services are supplied in accordance with these Terms, subject to any
              rights you have consumer protection laws that cannot be excluded.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) We accept our liability to you for breach of contract, negligence and for breach
              of any rights you have under consumer protection laws that cannot be excluded.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>However, we are not liable to you for any
              loss:
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>caused by you (e.g. through your
              negligence or breach of contract);
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) arising from your failure to take reasonable steps to avoid or minimise your
              loss; or
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) caused by our failure to comply with our obligations in relation to the Rental
              Services where that is caused by events outside our reasonable control (e.g. a failure
              in systems not owned or operated by us, etc.).
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(d) We are also not liable to you for:</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i)
              <span className={css.cl8}>&nbsp;&nbsp;</span>your inability to access the Platform or
              use the Rental Services;
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) acts or omissions of a transportation provider involved in a Direct Pick Up/Drop
              Off; or
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (iii) damage or loss caused by any use of the Platform that is contrary to these
              Terms, or which is unusual or a non-recommended use of the Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) You are liable to us for breach of contract or negligence. However, you are not
              liable to us for any loss to the extent that it is caused by us (e.g. through our
              negligence or breach of contract).
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (f)
              <span className={css.cl8}>&nbsp;&nbsp; </span>We will not be liable for any special,
              indirect, consequential or economic loss or damage or loss of profits (in contract or
              tort or arising from any other cause of action) suffered by you or any other person
              from any act or omission by us in relation to these Terms.
            </span>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (g) Consumer protections laws, including the Australian Consumer Law, confer rights on
              consumers that are not affected by these Terms. Nothing in these Terms exclude or
              limit any implied terms, guarantees or rights under those laws.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 11. </span>
            </b>{' '}
            <b>
              <span className={css.cl0}> Dispute Resolution </span>
            </b>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (a) In the event of a dispute between an Owner and a Renter, you agree to first
              attempt to resolve the issue directly with the other party using the Platform's
              messaging feature.
            </span>
          </p>
          <p className={css.cl6}>
            <span className={css.cl1}>
              (b) If a resolution cannot be reached, either party may refer the dispute to
              Kindershare for mediation. You agree that Kindershare may, at its sole discretion,
              review the dispute and make a final and binding determination on matters relating to
              the use of the Platform, including but not limited to, claims for Bonds, damage, or
              non-return of items.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 12. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> General </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) Force Majeure: If a circumstance beyond our reasonable control occurs and we are
              unable to offer the Rental Services or operate the Platform (including a Covid-19
              related event or other public health emergency), we may totally or partially suspend
              the Rental Services or the Platform for the duration of that event.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) Our relationship: The relationship between you and us is one of independent
              contractor only. Nothing in these Terms is intended to constitute a fiduciary
              relationship, agency, partnership or trust between us.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>Assignment or transfer: We may without notice
              to you assign, novate, transfer and/or sub-contract our rights and/or obligations
              under these Terms to any related body corporate or any purchaser of the whole or any
              part of the Kindershare business.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (d) Severability: Each clause in these Terms is severable and if any clause is held to
              be illegal or unenforceable, then the remaining clauses will remain in full force and
              effect.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e)
              <span className={css.cl8}>&nbsp; </span>No waiver: No failure or delay by a party in
              exercising any power, right or remedy prevents that party’s right to subsequently
              enforce that provision. Any such failure or delay is not to be treated as a waiver.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (f)
              <span className={css.cl8}>&nbsp;&nbsp; </span>Amendments: We may change these Terms
              from time to time, in which case we will post the new terms on the Platform and they
              will apply to your subsequent or continued use of the Platform from the date of
              publication. However, for any previous use of the Rental Services, the Terms that
              applied at the relevant time will continue to apply in relation to that previous use
              of the Rental Services.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (g) Governing law: These Terms are governed by the laws of New South Wales.
            </span>
          </p>
          <p className={css.cl2}>
            <b>
              <span className={css.cl0}> 13. </span>
            </b>
            <span className={css.cl1}> </span>
            <b>
              <span className={css.cl0}> Defined terms and interpretation </span>
            </b>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> In these Terms: </span>
            </b>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>(a) a reference to:</span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (i) “<b>we</b>”, “<b>us</b>”, “<b>our</b>” or “" <b>Kindershare</b>” refers to Sydney
              Data Services Pty Ltd (ACN 641 996 367) t/as Kindershare; and
            </span>
          </p>
          <p className={css.cl4}>
            <span className={css.cl1}>
              (ii) “<b>you</b>” or “<b>your</b>” means a user of the Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) capitalised terms have the meaning below unless the context requires otherwise:
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Bond </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means the security deposit given by the Renter as a condition of its rental of the
              Children’s Equipment from the Owner. Whether a security deposit is required, its value
              will be determined by the Owner at the time of posting Children’s Equipment on the
              Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Children’s Equipment </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means items and equipment that are principally designed or designated for use by
              babies, children or caregivers, or for the benefit or safety of babies, children or
              caregivers, or which are otherwise intended to be used for the entertainment,
              nourishment, nurturing, transportation or well-being of babies, children and
              caregivers, including:
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) safety equipment, car seats, harnesses, strollers and travel equipment;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) educational materials, entertainment equipment, sporting equipment or clothing,
              party equipment or decorations, toys and books;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>nursing, maternity and pregnancy related
              items;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (d) furniture, beds, chairs, tables, crockery, glassware, feeding equipment, food
              preparation items, floor coverings, furnishings, linen, marquees and items relating to
              hosting of events and parties;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (e) costumes, fancy dress, sport or other clothing, evening wear, fashion accessories,
              protective clothing or uniforms; and
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (f)
              <span className={css.cl8}>&nbsp;&nbsp; </span>any other items reasonably connected or
              incidental to the above.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Direct Pickup/Drop Off </span>
            </b>
            <span className={css.cl1}> means an arrangement:</span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (a) for the Renter to pick up the Children’s Equipment from the Owner at the start of
              the Rental Period;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (b) for the Owner to drop off the Children’s Equipment to the Renter at the start of
              the Rental Period;
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (c)
              <span className={css.cl8}>&nbsp; </span>for the Renter to drop off the Children’s
              Equipment to the Owner at the end of the Rental Period; or
            </span>
          </p>
          <p className={css.cl7}>
            <span className={css.cl1}>
              (d) for the Owner to pick up the Children’s Equipment from the Renter at the end of
              the Rental Period.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Intellectual Property Rights </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means all forms of intellectual property rights (whether registered or unregistered)
              in copyright, designs, patents, trademarks, domain names, trade secrets, know-how,
              confidential information, and all other similar proprietary rights and all extensions
              and renewals thereof anywhere in the world which currently exist and/or are recognised
              in the future.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Kindershare </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means Sydney Data Services Pty Ltd (ACN 641 996 367) t/as Kindershare.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Kindershare Fee </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means the service fee, the amount or percentage of which is displayed to the Owner at
              the time of listing. This percentage may be waived or lowered as part of a Promotional
              Discount or as otherwise agreed between Kindershare and an Owner.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Owner </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means a user of the Platform that rents out Children’s Equipment to a Renter via the
              Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Owner Terms </span>
            </b>
            <span className={css.cl1}> means clause 3 of these Terms, which apply to Owners.</span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Platform </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means the online platform operated by us and which facilitates the sharing and rental
              of Children’s Equipment between Owners and Renters via the Website and any other
              related systems and interfaces.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Privacy Policy </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means the privacy policy on our Website, as amended from time to time.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Promotional Discount </span>
            </b>
            <span className={css.cl1}> has the meaning given in clause 7(e).</span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Rental Charges </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means the amount of money payable by the Renter for each item Children’s Equipment
              rented out, via the Platform, including any applicable taxes. We will deduct the
              Kindershare Fee from the Rental Charges prior to paying this amount to the Owner.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Rental Period </span>
            </b>
            <span className={css.cl1}> has the meaning given in clause 3.4(g).</span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Rental Services </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means the online marketplace we provide, via the Platform, that enables Owners to rent
              out Children’s Equipment to Renters.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Renter </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means a user of the Platform that has agreed to rent Children’s Equipment from an
              Owner via the Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Renter Terms </span>
            </b>
            <span className={css.cl1}> means clause 4 of these Terms, which apply to Renters.</span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Terms </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means these terms and conditions of access to, and use of, the Platform.
            </span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Total Fee </span>
            </b>
            <span className={css.cl1}> has the meaning given in clause 4.4(e).</span>
          </p>
          <p className={css.cl7}>
            <b>
              <span className={css.cl3}> Website </span>
            </b>
            <span className={css.cl1}>
              {' '}
              means our website at{' '}
              <span>
                <a href="https://www.kindershare.com/">
                  <span className={css.cl5}>www.kindershare.com</span>
                </a>
              </span>
            </span>
          </p>
          <p>
            <span className={css.cl15}></span>
          </p>
        </>
      </div>
    </div>
  );
};

TermsOfService.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

TermsOfService.propTypes = {
  rootClassName: string,
  className: string,
};

export default TermsOfService;
